export default {
  async sentChatMessage({rootGetters, dispatch}, [name, data]) {
    dispatch('mixpanelTrack', [name, {
      'chat title': rootGetters.getCurrentChatTitle,
      'chat id': rootGetters.getCurrentChatId,
      ...data
    }])
  },
  async reactToChatMessage({rootGetters, dispatch}, [emoji, toggleState, messageId]) {
    dispatch('mixpanelTrack', ['React To Chat Message', {
      'chat title': rootGetters.getCurrentChatTitle,
      'chat id': rootGetters.getCurrentChatId,
      'Emoji': emoji,
      'Toggle State': toggleState,
      'Message Id': messageId
    }])
  },
  async deleteChatMessage({rootGetters, dispatch}, [messageId, isAdmin]) {
    dispatch('mixpanelTrack', ['Delete Chat Message', {
      'chat title': rootGetters.getCurrentChatTitle,
      'chat id': rootGetters.getCurrentChatId,
      'Message Id': messageId,
      'Is Space Admin': isAdmin
    }])
  },
  async deleteAllChatMessages({rootGetters, dispatch}) {
    dispatch('mixpanelTrack', ['Delete All Chat Messages', {
      'chat title': rootGetters.getCurrentChatTitle,
      'chat id': rootGetters.getCurrentChatId
    }])
  },
}
